import React from "react";
import ReportActionBar from "./ReportActionBar";
import ReportAIAnalysis from "./ReportAIAnalysis";

/**
 * ReportResults component - Renders the results/visualization area for a report
 * This is consumed by ProductionReport, EfficiencyReport, and RawOnOffReport
 * to handle the common layout of action bar, content area, and AI analysis panel.
 */
export default function ReportResults({
    children, // The main graph/chart/content to display
    deviceList = [],
    selectedDeviceIndex = 0,
    onPrevDevice,
    onNextDevice,
    hideEmptyDevices = false,
    onHideEmptyDevicesChange,
    autoRefresh = false,
    onAutoRefreshChange,
    showThresholds = true,
    onShowThresholdsChange,
    loading = false,
    onRefresh,
    onFavoriteClick,
    onPrintClick,
    onDownloadCSV,
    printRef,
    // AI Analysis panel props
    isAIAnalysisOpen = false,
    isAIAnalyzing = false,
    aiResults = null,
    aiError = null,
    onCloseAIAnalysis,
    onAIFollowUp,
}) {
    return (
        <div className="tw-flex-1 tw-flex tw-flex-col tw-gap-4">
            {/* Action Bar */}
            <ReportActionBar
                deviceList={deviceList}
                selectedDeviceIndex={selectedDeviceIndex}
                onPrevDevice={onPrevDevice}
                onNextDevice={onNextDevice}
                hideEmptyDevices={hideEmptyDevices}
                onHideEmptyDevicesChange={onHideEmptyDevicesChange}
                autoRefresh={autoRefresh}
                onAutoRefreshChange={onAutoRefreshChange}
                showThresholds={showThresholds}
                onShowThresholdsChange={onShowThresholdsChange}
                loading={loading}
                onRefresh={onRefresh}
                onFavoriteClick={onFavoriteClick}
                onPrintClick={onPrintClick}
                onDownloadCSV={onDownloadCSV}
                printRef={printRef}
            />

            {/* Main Content Area */}
            <div className="tw-flex-1" ref={printRef}>
                {children}
            </div>

            {/* AI Analysis Panel */}
            <ReportAIAnalysis
                isOpen={isAIAnalysisOpen}
                isAnalyzing={isAIAnalyzing}
                results={aiResults}
                error={aiError}
                onClose={onCloseAIAnalysis}
                onFollowUp={onAIFollowUp}
            />
        </div>
    );
}
